'use client'
// Shared chip-row primitive for the material and coverage tier pickers. Both
// the booking wizard and the public quote page render through this one
// component (DRY). Native buttons, not HeroUI: HeroUI v3 has no toggle-chip
// primitive and its Button has no color prop and does not surface
// aria-pressed semantics, so this stays a hand-rolled control per the plan.
interface TierChipRowProps<K extends string> {
  label: string
  options: ReadonlyArray<{ key: K; label: string; hint?: string }>
  value: K
  onChange: (key: K) => void
}
export function TierChipRow<K extends string>({ label, options, value, onChange }: TierChipRowProps<K>) {
  return (
    <div role="group" aria-label={label} className="flex flex-wrap gap-2">
      <span className="w-full text-sm text-muted">{label}</span>
      {options.map((o) => (
        <button
          key={o.key}
          type="button"
          aria-pressed={value === o.key}
          onClick={() => onChange(o.key)}
          className={`rounded-full border px-3 py-1 text-sm ${
            value === o.key ? 'border-accent bg-accent/10 text-foreground' : 'border-divider text-muted'
          }`}
        >
          {o.label}
          {o.hint ? <span className="ml-1 text-xs text-muted">{o.hint}</span> : null}
        </button>
      ))}
    </div>
  )
}
